import Clients from '@domains/clients/views/Clients.vue'

export default [
  {
    path: 'clients',
    component: Clients,
    name: 'Clients',
    props: (route) => ({
      search: route.query.search,
      clientId: route.query.clientId,
      documentId: route.query.documentId,
      onboardingStatus: route.query.onboardingStatus,
      onboardedAt: route.query.onboardedAt,
      orderBy: route.query.orderBy,
      id: route.query.id,
      idOnboarding: route.query.idOnboarding,
      lastClosedOperationNewerThan: route.query.lastClosedOperationNewerThan,
      institution: route.query.institution,
      clientType: route.query.clientType
    })
  }
]
